import { Block } from "@components/block";
import { Button } from "@components/button";
import { Input } from "@components/input";
import { useForm } from "react-hook-form";
import styles from "./styles.module.scss";
import { Grid, GridCol } from "@components/grid";
import { useEffect, useState } from "react";
import { useAdminGeneral } from "@features/admin/general";
import { FlexLoader } from "@components/loader";

type FormType = {
  telegram_chat_id_support: string;
  telegram_chat_id_admin: string;
  telegram_chat_id_superadmin: string;
};

export const AdminNotificationBot = () => {
  const { control, handleSubmit, setValue } = useForm<FormType>();
  const {
    state,
    updateGroupNotification,
    getAllGroupNotification,
  } = useAdminGeneral();
  const [groupType, setGroupType] = useState<
    "super_user" | "administrator" | "customer_support" | null
  >(null);

  useEffect(() => {
    getAllGroupNotification()
  }, [getAllGroupNotification]);

  useEffect(() => {
    setValue("telegram_chat_id_admin", state.telegram_chat_id_admin ?? "")
    setValue("telegram_chat_id_superadmin", state.telegram_chat_id_super ?? "")
    setValue("telegram_chat_id_support", state.telegram_chat_id_support ?? "")
  }, [state.telegram_chat_id_admin, state.telegram_chat_id_super, state.telegram_chat_id_support, setValue])

  const onSubmit = (data: FormType) => {
    let telegram_chat_id = "";
    switch (groupType) {
      case "super_user":
        telegram_chat_id = data.telegram_chat_id_superadmin;
        break;
      case "administrator":
        telegram_chat_id = data.telegram_chat_id_admin;
        break;
      case "customer_support":
        telegram_chat_id = data.telegram_chat_id_support;
        break;
      default:
        return;
    }

    if (groupType == null) return;

    const transformedData = {
      group_type: groupType,
      telegram_chat_id,
    };

    updateGroupNotification(groupType, transformedData);
  };

  return (
    <Block>
      <h3 className={styles.header}>Уведомления Бот</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        {state.loading ? (
          <FlexLoader />
        ) : (
          <Grid>
            <GridCol span={6}>
              <Input
                control={control}
                name="telegram_chat_id_superadmin"
                label="Super-Admin"
                className={styles.input}
              ></Input>
            </GridCol>
            <GridCol span={6}>
              <Button
                style={{ marginTop: "23px" }}
                buttonType="submit"
                onClick={() => {
                  setGroupType("super_user");
                }}
              >
                Сохранить
              </Button>
            </GridCol>
            <GridCol span={6}>
              <Input
                control={control}
                name="telegram_chat_id_admin"
                label="Admin"
                className={styles.input}
              ></Input>
            </GridCol>
            <GridCol span={6}>
              <Button
                buttonType="submit"
                style={{ marginTop: "23px" }}
                onClick={() => {
                  setGroupType("administrator");
                }}
              >
                Сохранить
              </Button>
            </GridCol>
            <GridCol span={6}>
              <Input
                control={control}
                name="telegram_chat_id_support"
                label="Support"
                className={styles.input}
              ></Input>
            </GridCol>
            <GridCol span={6}>
              <Button
                buttonType="submit"
                style={{ marginTop: "23px" }}
                onClick={() => {
                  setGroupType("customer_support");
                }}
              >
                Сохранить
              </Button>
            </GridCol>
          </Grid>
        )}
      </form>
    </Block>
  );
};
